import { css } from 'aphrodite';
import * as React from 'react';
import { useCallback } from 'react';
import { useManagerPermissions } from '../../hooks/useManagerPermissions';
import { styleSheet } from './styles';

interface ClickableSDRNameProps {
	userId: string;
	userName: string;
	className?: string;
	children?: React.ReactNode;
	onClick?: (userId: string, userName: string) => void;
}

export const ClickableSDRName: React.FC<ClickableSDRNameProps> = ({
	userId,
	userName,
	className = '',
	children,
	onClick,
}) => {
	const { hasManagerPermissions } = useManagerPermissions();

	const handleClick = useCallback(
		(e: React.MouseEvent) => {
			if (!hasManagerPermissions || !onClick) return;

			e.preventDefault();
			e.stopPropagation();
			onClick(userId, userName);
		},
		[hasManagerPermissions, onClick, userId, userName]
	);

	if (!hasManagerPermissions) {
		// If not admin or manager, just render the name without any click functionality
		return <span className={className}>{children || userName}</span>;
	}

	return (
		<button
			type='button'
			onClick={handleClick}
			className={css(styleSheet.clickableButton) + (className ? ` ${className}` : '')}
			title={`Set coaching goals for ${userName}`}
		>
			{children || userName}
		</button>
	);
};
